import React from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { Pill, PillProps } from './Pill';

interface ClickablePillProps extends PillProps {
  onIconClick: () => void;
  icon?: React.ReactNode;
}

export function ClickablePill({
  onIconClick,
  icon,
  classes,
  children,
}: ClickablePillProps) {
  return (
    <Pill classes={classes}>
      <div className="flex flex-row space-x-2 items-center">
        <span>{children}</span>
        <span onClick={onIconClick} className="ml-1 cursor-pointer">
          {icon ?? <XMarkIcon className="h-5 w-5" />}
        </span>
      </div>
    </Pill>
  );
}
